// extracted by mini-css-extract-plugin
module.exports = {"button":"SwitchViewButton_button__2V-fr","closeButton":"SwitchViewButton_closeButton__3D00I"};